import React from 'react';
import styled from 'styled-components';

import { Button, ButtonTypes } from 'src/presentation/components/agent_desktop_components';
import EmptyPageLayout from 'src/presentation/components/pages/shared/EmptyPageLayout';
import { H2 } from '@ad-scripts/presentation/components/common/headers';
import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import SmsStrokeIcon from '@ad-scripts/presentation/components/common/icons/stroke/sms-stroke';

const SmsEmptyPage = ({ handleManageSms }): JSX.Element => {
  return (
    <EmptyPageLayout data-aid="empty-sms-page">
      <StyledSmsStrokeIcon />
      <H2 data-aid="header-title">Get started with SMS</H2>
      <EmptyPageDescription data-aid="header-description">
        Configure and manage your SMS setup to start interacting with customers via text message. Read{' '}
        <ExternalLink
          data-aid="set-up-sms-help-link"
          label="Set Up SMS"
          to="https://help.gladly.com/implementation/docs/set-up-sms"
        />{' '}
        to learn more.
      </EmptyPageDescription>
      <Button data-aid="action-button-set-up-sms" onClick={handleManageSms} buttonType={ButtonTypes.PRIMARY}>
        Set up SMS
      </Button>
    </EmptyPageLayout>
  );
};

const StyledSmsStrokeIcon = styled(SmsStrokeIcon)`
  fill: ${({ theme }) => theme.colors.gray600};
  margin-bottom: 20px;
  width: 40px;
`;

const EmptyPageDescription = styled.div`
  margin-bottom: 24px;
  max-width: 460px;
  text-align: center;
`;

export default SmsEmptyPage;
